export default function getActionRequestBody({
  action,
  developerNote,
  autopublish,
}) {
  if (action === 'publish_request' || action === 'suspension_removal_request') {
    return {
      developer_note: developerNote,
      auto_publish: autopublish,
    };
  }
  if (action === 'warning_removal_request') {
    return { developer_note: developerNote };
  }
  if (action === 'autopublish') {
    return { auto_publish: true };
  }
  if (action === 'cancel_autopublish') {
    return { auto_publish: false };
  }

  return null;
}
